import { compose } from 'redux';
import { connect } from 'react-redux';
import TRCBookStartView from './TRCBookStartView';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { TRC } from '../../../constants/measure';
import selectors from '../../../rootSelectors';
import { narrateScreen, fetchTRCContent } from '../../trcActions';
import {
    trackTROBookStart,
    trackStartPreAssessmentStep,
    trackNextPreAssesmentStep,
    trackCompletedPreAssessment,
} from '../../trcReporting';
import { getBookImages } from '../../../common/api/trcoActions';
import { stopAudio, narrateReset } from '../../../common/audio/audioActions';
import { setShouldPreventAlexAnimation } from '../../../common/alex/AlexActions';
import { unmountScreen, showSpinner, hideSpinner } from '../../../common/screen/screenActions';
import { getTrcInstruction, getTrcCaption, PRE_ASSESSMENT_STEPS } from '../../troConstants';
import { stopTimeTracking, resetPageRecordingTimeTracking } from '../../../common/timeTracking/timeTrackingActions';
import { TRO_PRE_ASSESSMENT_STEPS }  from '../../../common/timeTracking/timeTrackingKeys';

const trcRemindersInstruction = 'trcReminders';

const mapStateToProps = state => ({
    bookCover: selectors.getTRCBookCover(state),
    bookCoverAltText: selectors.getTRCBookCoverAltText(state),
    bookTitle: selectors.getTRCBookTitle(state),
    bookLevel: selectors.getTRCReadingLevel(state),
    bookIntroAudio: selectors.getBookIntroAudio(state),
    caption: selectors.getCaption(state),
    bookIndex: selectors.getBookIndex(state),
    isDataFetched: selectors.getIsTRCDataFetched(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isSpinnerVisible: selectors.getIsSpinnerVisible(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    arLanguage: selectors.getArLanguage(state),
    playlistItemInProgress: selectors.getPlaylistItemInProgress(state),
});

const mapDispatchToProps = dispatch => ({
    fetchContent: () => {
        dispatch(fetchTRCContent()).then(() => {
            dispatch(getBookImages());
            dispatch(resetPageRecordingTimeTracking());
        });
    },
    onNext: (isExternalURLSourcePresent) => {
        if (isExternalURLSourcePresent) {
            dispatch(trackTROBookStart());
        }
        dispatch(goToCountdown(TRC));
    },
    narrateScreen: (bookIntroAudio, caption, isExternalURLSourcePresent, playlistItemInProgress, arLanguage) => {
        // for AR users, the instructional video will have been skipped.
        // to make sure they understand what to do, play additional instructions if this is the first book
        const alyxAudio = getTrcInstruction(isExternalURLSourcePresent, trcRemindersInstruction, arLanguage);
        const alyxAudioCaption = getTrcCaption(isExternalURLSourcePresent, trcRemindersInstruction, arLanguage);
        const alyxAudioPromise = isExternalURLSourcePresent && !playlistItemInProgress ?
            dispatch(narrateScreen(alyxAudio, alyxAudioCaption)) : Promise.resolve();
        alyxAudioPromise.then(() => {
            dispatch(narrateScreen([bookIntroAudio], caption, true));
        });
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
        dispatch(setShouldPreventAlexAnimation(false));
    },
    showSpinner: () => dispatch(showSpinner()),
    hideSpinner: () => dispatch(hideSpinner()),
    trackStartPreAssessmentStep: () => dispatch(trackStartPreAssessmentStep(PRE_ASSESSMENT_STEPS.BOOK_INTRO)),
    trackNextPreAssesmentStep: () => dispatch(trackNextPreAssesmentStep(PRE_ASSESSMENT_STEPS.BOOK_INTRO)),
    trackCompletedPreAssessment: async () => {
        await dispatch(stopTimeTracking(TRO_PRE_ASSESSMENT_STEPS));
        dispatch(trackCompletedPreAssessment());
    },
});

const avatarMapStateToProps = state => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: selectors.getBookIntroAudio(state),
});

const TRCBookStartContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(TRCBookStartView);

export default TRCBookStartContainer;
